import type { BootstrapableForm } from "types";
import type { useForm } from "hooks";
import type { OnboardingApplication } from "features/ecommerce/types";

export const enum FormField {
    HasAgreedTermsConditions = 'hasAgreedTermsConditions'
};

export type OnboardingCompleteOnboaring<TApplication extends object> = Pick<OnboardingApplication<TApplication>, 'hasAgreedTermsConditions'>;

export type OnboardingCompleteOnboaringForm<TApplication extends object> =
    & Omit<
        BootstrapableForm<OnboardingCompleteOnboaring<TApplication>, {}>,
        | 'initialValues'
    >
    & {
        readonly initialValues: OnboardingCompleteOnboaring<TApplication>;
    };

export type OnboardingCompleteOnboaringProps<TApplication extends object> =
    & OnboardingCompleteOnboaringForm<TApplication>
    & ReturnType<typeof useForm<OnboardingCompleteOnboaring<TApplication>>>;
